


























import Vue from 'vue';
import store, { InvoiceFlowStore } from "../services/InvoiceFlowStore";

interface Data {
    store: InvoiceFlowStore;
}

interface Methods {
    loadPartnerRelations(): Promise<void>;
}

export default Vue.extend<Data, Methods, {}, {}>({
    data() {
        return {
            store,
        }
    },

    async beforeMount() {
        await this.loadPartnerRelations();
    },

    watch: {
        // Iktatás előtt is látszik a választó, így partnerváltáskor frissíteni kell a relációkat
        async "store.invoice.partner"() {
            await this.loadPartnerRelations();
        },
    },

    methods: {
        async loadPartnerRelations() {
            // if (this.store.invoice.partner < 2) return;

            // Csak akkor töltünk, ha a store-ban még nem a jelenlegi (partner-id) párra van betöltve.
            // Így nem írjuk felül egy esetleges, már létrehozott (createSupplierRelation) relációt.
            const key = `${this.store.invoice.partner}-${this.store.invoice.id}`;
            if (this.store.partnerRelationsLoadedFor !== key) {
                await this.store.getPartnerRelationsWithSelectedPartnerRelation(this.store.invoice.partner, this.store.invoice.id);
            }
        },
    },

    computed: {
        selectedPartnerRelationComputed() {
            return this.store.selectedPartnerRelation;
        }
    },
})
